import React from "react";

import clsx from "clsx";
import { rem, transparentize } from "polished";
import styled, { css } from "styled-components";

import { useMountTransition } from "../../hooks/use-mount-transition";
import Portal from "../../hooks/use-portal";

const Button = ({
  children,
  onClick,
  className = "",
  variant = "",
  skin = "",
}) => {
  return (
    <ButtonLayout className="builder-button" variant={variant} skin={skin}>
      <button onClick={onClick} className={className}>
        <span>{children}</span>
      </button>
    </ButtonLayout>
  );
};
export default Button;

export const ButtonWrapper = styled.div`
  margin-top: 15px;
`;

const ButtonLayout = styled.div`
  ${({ theme, variant, skin }) => css`
    button {
      width: 100%;
      background-color: ${theme.colors.black};
      border: none;
      padding: 22px 40px;
      cursor: pointer;
      position: relative;
      color: ${theme.colors.white};
      overflow: hidden;
      transition: 0.3s ease all;
      border-radius: 42px;
      text-align: left;

      ${skin === "red" &&
      css`
        background-color: ${theme.colors.primary};
        color: ${theme.colors.white};

        &:hover {
          opacity: 0.9;
        }
      `}

      ${variant !== "normal" &&
      css`
        &::after {
          content: "";
          position: absolute;
          right: 30px;
          width: 12px;
          height: 12px;
          border-color: #fff;
          border-top: 2px solid;
          border-right: 2px solid;
          transform: rotate(45deg);
          transition: 0.3s ease all;
          pointer-events: none;
        }

        &:hover {
          color: #fff;
          &::after {
            right: 20px;
          }
        }
      `}

      span {
        position: relative;
        z-index: 1;
      }
    }
  `}
`;
